// frontend/src/graphql/queries/getBlockchainStats.js
import { gql } from "@apollo/client";

export const GET_BLOCKCHAIN_STATS = gql`
  query GetBlockchainStats {
    blockchainStats {
      network
      latestBlock
      gasPrice
      status
    }
  }
`;
